import { app } from "../context/firebaseConfig";

const db = app.firestore();

export const getUserData = async (uid) => {
  return await db
    .collection("users")
    .doc(uid)
    .get()
    .then((data) => {        
        return data.data();
    })
    .catch((err) => {
      return err;
    });
};

export const getAddress = async (uid) => {
  return await db
    .collection("users")
    .doc(uid)
    .collection("address")
    .get()
    .then((res) => {
      return res.docs;
    })
    .catch((err) => {
      return err;
    });
};

export const saveAddress = async (uid, addrs) => {
  return await db
    .collection("users")
    .doc(uid)
    .collection("address")
    .add(addrs)
    .then((_) => {
      return 1;
    })
    .catch((_) => {
      return 0;
    });
};

export const pushOrder = async (uid, suc, order) => {
  // const a = await db
  //   .collection("users")
  //   .doc(uid)
  //   .set({ order: true }, { merge: true })
  //   .then((res) => res)
  //   .catch((err) => err);

  // const b = 
  await db
    .collection("sucursales")
    .doc(suc)
    .collection('orders')
    .add(order) //, { merge: true }
    .then((res) => res)
    .catch((err) => err);

  //return { a, b };
};
